export enum ComplianceDocumentType {
  RegularInvoice = 0,
  SimplifiedInvoice = 1,
  CreditNote = 2,
  DebitNote = 3,
  CorrectiveInvoice = 4,
  CancelInvoice = 5,
}

export enum DocumentClassType {
  Invoice = 0,
  PurchaseOrder = 1,
  DeliveryNote = 2,
  CreditNote = 10,
  DebitNote = 11,
  GoodsReceivedNote = 33,
}
